var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"padding-top":"15px","padding-bottom":"15px"}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.analysis),function(a,i){return _c('v-flex',{key:i,staticClass:"pa-3",attrs:{"md3":""}},[_c('fs1-span',[_c('b',[_vm._v(_vm._s(a.label)+" ")]),_c('span',[_vm._v(_vm._s(a.value))])])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }